export default class StayPoints {
  static empty() {
    return new StayPoints({})
  }

  static fromJSON(json, accumulated) {
    return new StayPoints({
      amountPerNight: json.averagePricing?.pointsExtended?.points,
      undiscountedAmountPerNight: json.averagePricing?.pointsExtended?.undiscountedPoints,
      totalAmountForAllNights: (json.nights || []).reduce(
        (accum, night) => accum + night.pricing.points,
        0
      ),
      accumulated: accumulated,
      nights: json.nights.length
    })
  }

  constructor({
    amountPerNight,
    undiscountedAmountPerNight,
    totalAmountForAllNights,
    accumulated,
    nights
  }) {
    this.amountPerNight = amountPerNight || 0
    this.undiscountedAmountPerNight = undiscountedAmountPerNight || 0
    this.totalAmountForAllNights = totalAmountForAllNights || 0
    this.percentageOfDiscountPerNight =
      this.hasPoints() && this.hasDiscount()
        ? parseInt(((1 - this.amountPerNight / this.undiscountedAmountPerNight) * 100).toFixed(0))
        : 0
    this.accumulated = accumulated || {}
    this.nights = nights
  }

  hasPoints = () => this.amountPerNight > 0
  hasDiscount = () => this.undiscountedAmountPerNight > 0
  isAccumulated = () => !!(this.hasPoints() && this.accumulated?.hotel && this.nights >= 2)
}
